import { Injectable, Inject } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import { Router } from "@angular/router";
import { ActionNotification } from '../../models/notification/action-notification.model';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { CookieService } from 'ngx-cookie-service';

@Injectable()
export class ActionNotificationService {
  private service = "api/ActionNotification"; //Controller Name
  private roleHelperService = "api/RoleManagement"; //Controller Name
  public notificationList: ActionNotification[];

  constructor(private http: Http, private readonly router: Router, private cookieService: CookieService) { }

  AddActionNotification(actionNotification: ActionNotification): void {
    this.http
      .post(`${this.service}`, actionNotification, {
        headers: new Headers({
          "Token": this.cookieService.get('Login')
        })
      })
      .subscribe(result => {
        this.router.navigate(["/action-notification-list"]);
      });
  }
  UpdateActionNotification(actionNotification: ActionNotification): void {
    this.http
      .put(`${this.service}`, actionNotification, {
        headers: new Headers({
          "Token": this.cookieService.get('Login')
        })
      })
      .subscribe(result => {
        this.router.navigate(["/action-notification-list"]);
      });
  }

  GetActionNotifications() {
    return this.http.get(`${this.service}`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  GetActionNotificationById(id: string) {
    return this.http.get(`${this.service}/` + id, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => <Notification>response.json())
      .catch(this.errorHandler)
  }
  DeleteActionNotification(id: string) {
    return this.http.delete(`${this.service}/` + id, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .subscribe(result => {
      });
  }
  errorHandler(error: Response) {
    
    return Observable.throw(error);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/notification/action-notification.service.ts